import React, { useMemo } from 'react'
import { Box, Button } from '@mui/material'
import {
  atom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'
import { useGetUpdateData, useUpdatesActions } from './utility'
import { selectedUpdatesAtom } from './atoms'
import { ProductMultiSelect } from '../migration/ProductMultiSelect'
import { useAtom } from 'infrastructure/state/jotai.wrapper'

const isAddingAtom = atom(false)
const gettingUpdatesAtom = atom(false)
const retrievingIdsAtom = atom<number[]>([])

export function AccumulatorOptions() {
  return (
    <Box>
      <IsAddingToggle />
      <ProgressMessage />
      <UpdatesSelection />
    </Box>
  )
}

function UpdatesSelection() {
  const [isAdding, setAddingUpdate] = useAtom(isAddingAtom)
  const [gettingUpdates, setGettingUpdates] = useAtom(gettingUpdatesAtom)
  const updates = useAtomValue(selectedUpdatesAtom)
  const updateGetter = useGetUpdateData()
  const updateActions = useUpdatesActions()
  const setRetrievingIds = useSetAtom(retrievingIdsAtom)

  const currentSelections = useMemo(() => {
    return updates.map(({ productId }) => productId)
  }, [updates])

  const onSelect = async (ids: number[]) => {
    setGettingUpdates(true)
    setAddingUpdate(false)
    setRetrievingIds([...ids])
    await ids.reduce(async (acc, productId) => {
      await acc
      return updateGetter(productId).then((updates) => {
        if (!updates) return
        updateActions.addUpdate(updates)
      })
    }, Promise.resolve())
    setRetrievingIds([])
    setGettingUpdates(false)
  }

  if (!isAdding || gettingUpdates) return null

  return <ProductMultiSelect onSelect={onSelect} selected={currentSelections} />
}

function IsAddingToggle() {
  const updates = useAtomValue(selectedUpdatesAtom)
  const isGetting = useAtomValue(gettingUpdatesAtom)
  const [isAdding, isAddingSetter] = useAtom(isAddingAtom)
  if (isAdding || isGetting) {
    return null
  }
  return (
    <Box>
      <Button onClick={() => isAddingSetter(true)}>
        Add {!!updates.length && 'Another '}Update
      </Button>
    </Box>
  )
}

function ProgressMessage() {
  const retrievingIds = useAtomValue(retrievingIdsAtom)
  if (!retrievingIds.length) return null
  return (
    <Box padding="10px">{`Getting updates data for ${retrievingIds.length} trees, please wait...`}</Box>
  )
}
